import { RowLayout } from "chorda-bulma";
import { Example } from "../../helpers";
export const NavbarExample = () => {
    return RowLayout([
        Example({
            title: 'Basic',
            content: require('./basic').default,
            code: require('!raw-loader!./basic').default
        }),
    ]);
};
